import React from "react";
import { Link } from "react-router-dom";
import RequireAuth from "../auth/RequireAuth";
import { Header } from "../components/Header";

import "../css/general.css";
import "./AdminWindow.css";

function AuthMessage() {
  return (
    <div>
      У Вас недостаточно прав для работы с административной панелью.
      <a href="/login">Войдите</a> как администратор.
    </div>
  );
}

export default function AdminWindow() {
  return (
    <>
      <Header/>
      <main className="admin-panel centering">
        <h1>Управление пользователями</h1>
        <RequireAuth roles={["admin", "developer"]} public={AuthMessage}>
          <div className="btn-group-vertical admin-panel-sections">
            <Link className="btn btn-default" to="/comments">Просмотреть список комментариев и вопросов пользователей</Link>
            <Link className="btn btn-default" to="/create">Создать нового пользователя</Link>
            <Link className="btn btn-default" to="/users">Просмотреть список всех пользователей</Link>
          </div>
        </RequireAuth>
      </main>
    </>
  );
}
